export default "__VITE_ASSET__BrdeKRJ3__"